// @ts-nocheck
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import type {EarningsGraphData} from 'src/types/referrer-portal';
import {useWindowSize} from '@spaced-out/ui-design-system/lib/hooks/useWindowSize';
import {BodySmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {useSelector} from 'react-redux';
import css from 'src/components/referrer-portal/earnings/earnings.css';


const EarningsGraph = () => {
  const {language} = useLabelTranslation();
  const earningsData: EarningsGraphData | null | undefined = useSelector(
    (state) => state.referrerPortal.earnings_graph_data,
  );

  const months = Array.from({length: 12}, (_, i) => ({
    key: new Date(2000, i).toLocaleString(language, {month: 'short'}),
    value: i + 1,
  }));

  const yValues = ['$0', '$1k', '$2k', '$3k', '$4k', '$5k'];
  const windowSize = useWindowSize();

  const chartWidth = windowSize.width / 2 - 100;

  const chartHeight = 400;
  const margin = {top: 20, right: 30, bottom: 30, left: 40} as const;

  const width = chartWidth - margin.left - margin.right;
  const height = chartHeight - margin.top - margin.bottom;

  const xScale = (monthNumber: unknown) => (monthNumber - 1) * (width / 11);

  const yScale = (value: unknown) => {
    return (
      height -
      (parseFloat(value.replace('$', '').replace('k', '')) / 5) * height
    );
  };

  const yScaleProgress = (value: unknown) =>
    height - (parseFloat(value) / 1000 / 5) * height;

  const medianEarning = `$${(
    parseInt(earningsData?.median_earning) / 1000
  ).toFixed(1)}k`;

  const monthWiseEarnings = months.map((month) => ({
    month: month.value,
    earnings: earningsData ? earningsData.month_wise_earnings[month.value] : 0,
  }));

  return (
    <svg width={chartWidth} height={chartHeight}>
      <g transform={`translate(${margin.left},${chartHeight - margin.bottom})`}>
        {months.map((month) => (
          <g
            key={month.value}
            transform={`translate(${xScale(month.value)}, 0)`}
          >
            <text
              className={css.graphText}
              x={10}
              y={10}
              dy="1em"
              textAnchor="middle"
            >
              {month.key}
              <BodySmall>{month.key}</BodySmall>
            </text>
          </g>
        ))}
      </g>

      <g transform={`translate(${margin.left},${margin.top})`}>
        {yValues.map((value) => (
          <g key={value} transform={`translate(0, ${yScale(value)})`}>
            <line x1={0} y1={0} x2={width} y2={0} stroke="#E1E1E1" />
            <text className={css.graphText} x={-10} y={4} textAnchor="end">
              {value}
            </text>
          </g>
        ))}
      </g>

      <line
        x1={40}
        y1={yScale(medianEarning) + 20}
        x2={chartWidth - margin.right}
        y2={yScale(medianEarning) + 20}
        stroke="#0769F0"
        strokeWidth={2}
        textAnchor="middle"
      />

      {monthWiseEarnings.slice(0, -1).map(({month, earnings}, index) => {
        return (
          <line
            key={month}
            x1={xScale(month) + 40}
            y1={yScaleProgress(earnings) + margin.top}
            x2={xScale(monthWiseEarnings[index + 1].month) + 40}
            y2={
              yScaleProgress(monthWiseEarnings[index + 1].earnings) + margin.top
            }
            stroke="#03964D"
            strokeWidth={2}
          />
        );
      })}
    </svg>
  );
};

export default EarningsGraph;
